import axiosInstance from "@/api/axiosInstance";
import { FetchPreEpChecklistResponse } from "./types";

export const fetchPreEpChecklist =
  async (): Promise<FetchPreEpChecklistResponse> => {
    const response = await axiosInstance.get<FetchPreEpChecklistResponse>(
      "/api/private/pre-ep/checklist",
    );

    return response.data;
  };
